import PropTypes from 'prop-types'
import React from 'react'
import { Form } from 'redux-form'
import { capitalize } from 'lodash'

import Button from '@hixme-ui/button'
import Checkbox from '@hixme-ui/checkbox'
import Container from '@hixme-ui/container'
import FormGroup from '@hixme-ui/form-group'
import Text from '@hixme-ui/text'

import { FieldComponent } from 'components/ReduxFormComponents'

import classes from './PersonCoverageForm.module.scss'

const formatPersonName = (firstName, lastName) =>
  [firstName, lastName].filter(Boolean).map(capitalize).join(' ')

const PersonCoverageForm = ({ handleSubmit, submitting, onCancelClick, persons }) => (
  <Form onSubmit={handleSubmit}>
    <FormGroup>
      <Container flex noPadding direction="column" className={classes.form}>
        {persons.map((field, index) => {
          const { FirstName, Id, LastName, disabled, selected } = field
          return (
            <Container
              flex
              noPadding
              margin="10px 0 10px"
              className={classes.personRow}
              key={`PersonSelect-${index.toString()}`}
            >
              <FieldComponent
                inputComponent={Checkbox}
                small
                normalize={(value) => value || false}
                type="checkbox"
                name={Id}
                text=""
                props={{ disabled, selected }}
              />
              <Text small className={classes.personName}>
                {formatPersonName(FirstName, LastName)}
              </Text>
            </Container>
          )
        })}
        <div className={classes.actions}>
          <div className={classes.actionButton}>
            <Button block secondary type="button" onClick={onCancelClick}>
              Cancel
            </Button>
          </div>
          <div className={classes.actionButton}>
            <Button submittingText="Saving..." submitting={submitting} block>
              Save
            </Button>
          </div>
        </div>
      </Container>
    </FormGroup>
  </Form>
)

PersonCoverageForm.displayName = 'CoverageSelection'

PersonCoverageForm.propTypes = {
  persons: PropTypes.array,
  onCancelClick: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  submitting: PropTypes.bool,
}

PersonCoverageForm.defaultProps = {
  persons: [],
  submitting: false,
}

export default PersonCoverageForm
